import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { withOidcSecure } from '@axa-fr/react-oidc';
import Loader from '../../../CustomComponents/Loader';
import LineBreaks, { ClimbCard, ClimbCardPlus, retrieveData, generateClimbData } from "../../../../utils";
import { ClimbMenuSidebar } from "../../../../utils";
import HomeLayout from "../../../Layout/HomeLayout";
import lock from '../../../../assets/images/lock.png';
import { getUserMembership } from "../../../../helpers/utils/Utils";
import { GetApiHeadersWithBearer, GetRequest } from "../../../../network/NetworkUtils";
import { CAN_CREATE_SAVINGS_ACC, COVERED_BY_KUDZU_PLUS, GET_CLIMB_FEATURES, SAVING_CARD_CODE, SAVINGS_GOALS, STATUS_SUCCESS_CODE, PAID_PROMO_KEY } from "../../../../network/URLConstants";
import { useDispatch, useSelector, connect } from 'react-redux';
import Cards from "../../../CardServices/Cards";
import CustomAlertModel from "../../../CustomComponents/CustomAlertModel";
import Modal from "../../../CustomComponents/Modal";
import { useLocation, useNavigate } from "react-router";
import moment from "moment";
import FooterContent from "../../../CustomComponents/Footer";
// import { addLineBreaks } from '../../utils';
import { addLineBreaks } from "../../../../utils";
import kudzuPlusLogo from "../../../../assets/kudzu-plus-images/kudzu-plus-white-logo.png";
import Mask from '../../../../assets/images/Mask.png'
import Cardbg from '../../../../assets/images/Cardbg.png';
import { appTheme, showKudzuPlusPrompt } from "../../../../helpers/utils/Utils";
import CustomModalPlus from "../../../../kudzu_plus/helpers/customModalPlus";
import MemnershipEnrollmentScreens from "../../../../kudzu_plus/components/membershipEnrollmentScreens";
import Climb from '../../Climb/index'
import logFirebaseEvents from "../../../LogFirebaseEvents";
import Arrow from '../../../../assets/kudzu-plus-images/arrow-image.png';
import { useDocumentTitle } from '../../../../hooks/useDocumentTitle';






const ClimbMenu = () => {
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue); 
    const appThemeData = appTheme(kudzuPlusTrue)
    const { t } = useTranslation();
    useDocumentTitle(t('page_title_financial_toolkit'));
    const dispatch = useDispatch();
    
    const [isLoading, setIsLoading] = useState(false);
    const cards = useSelector(state => JSON.parse(state.userCards));
    const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
    const accessToken = useSelector(state => state.accessToken);
    const [isClimbings, setisClimbings] = useState([]);
    const [isShowTick, setShowTick] = useState(false);
    const isPrimrayKey = cards !== null ? cards[0].CardKey : 0;
    const selectedItem = cards?.[0]
    const userId = useSelector(state => state.userId);
    const [loading, setLoading] = useState(false)
    const InputStyles = "font-hanken-grotesk  text-secondary-2 px-4 bg-text-btn placeholder-kudzu-blue lg:text-[16px] md:text-[15px] text-[14px] placeholder:font-semibold font-medium focus:outline-none w-full h-[60px]";
    const SubHeadingStyles = "w-[90%] md:w-full font-serif-pro modal-title sm:text-[18px] lg:text-[32px] md:text-[28px] text-[25px] sm:leading-[24px] lg:leading-[38px] md:leading-[33px] leading-[31px] font-normal text-[var(--modal-text-heading-clr)]";
    const SubHeadingStyles2 = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal text-[var(--modal-text-highlight)] pl-1 pr-1 mb-4";

    const [showErrorImg, setshowErrorImg] = useState(false);

    const HighlightMsgStyles = "sm:w-auto w-[253px] font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal text-[#2965FB] cursor-pointer pointer-events-none";
    const HeaderMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal cursor-pointer pointer-events-none";
    const SubHeaderMsgStyles = "font-hanken-grotesk modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer pointer-events-none";
    const SubHeaderMsgStylesPlus = "font-hanken-grotesk modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer pointer-events-none text-[var(--modal-text-heading-clr)]";
    const HeaderMsgStylesForPlus = "font-serif-pro text-white modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal cursor-pointer pointer-events-none";
    const summaryParagraphStyles = "font-hanken-grotesk modal-title text-[#94C3E8] lg:text-[13px] md:text-[13px] sm:text-[6px] text-[8px] font-[400] cursor-pointer pointer-events-none";
    const [highlightMsg, setHighlightMsg] = useState('')
    const [headerMsg, setheaderMsg] = useState('')
    const [subHeaderMsg, setSubHeaderMsg] = useState('')
    const [btn1Exists, setBtn1Exists] = useState(false)
    const [btn2Exists, setBtn2Exists] = useState(false)
    const [btn1Text, setBtn1Text] = useState(false)
    const [btn2Text, setBtn2Text] = useState('')
    const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
    const [footerMsg, setFooterMsg] = useState('');
    const [showModel, setShowModel] = useState(false);
    const [modelImage, setModelImage] = useState('')
    const [savingsTheme, setSavingsTheme] = useState(false);
    const [isBorderNone, setisBorderNone] = useState(true);
    const [isSubFooter, setIsSubFooter] = useState(false);


    const [carousel, setCarousel] = useState('');
    const [summaryParagraph, setSummaryParagraph] = useState('');
    const [opacityValueLow, setOpacityValueLow] = useState(false);
    const [showPlusModal, setShowPlusModal] = useState(false);
    const [showCarouselScreenShow, setShowCarouselScreensShow] = useState(false);
    const [comparisonScreen, setComparisonScreen] = useState('');
    const [fullWidth, setFullWidth] = useState(false);
    const [footerButtonEnable, setFooterButtonEnable] = useState(false);
    const [gradientButton, setGradientButton] = useState(false);
    const [largeImage, setLargeImage] = useState(false);
    const [btn1BgColor, setBtn1BgColor] = useState("");
    const [skipAndNextButtonsEnable, setSkipAndNextButtonsEnable] = useState(false);
    const [subFooter, setSubFooter] = useState('');
    const [savingsGoalsIntoTrue, setSavingsGoalsIntoTrue] = useState(false);
    


    const accessTokenToApi = useSelector(state => state.accessToken);
    const isShowKudzuPlusPrompt = showKudzuPlusPrompt(loggedResponse);
    const showPrompt = showKudzuPlusPrompt(loggedResponse);
    

    const currentpath = useLocation()

    const { isClimbShowPopups } = currentpath.state || {};

    useEffect(() => {
        console.log(currentpath, "currentpath value from navbar")
    }, [])


    const navigate = useNavigate();
    const [isCoveredByKudzuIneligible, setIsCoveredByKudzuIneligible] = useState(false);
    const [isCoveredByKudzuIneligibleSetupSavings, setIsCoveredByKudzuIneligibleSetupSavings] = useState(false);
    const [isCoveredByKudzuIneligibleSetupSavingsPostPopup, setIsCoveredByKudzuIneligibleSetupSavingsPostPopup] = useState(false);
    const savingsWithBalanceOver50 = cards.find(
        obj => obj.AccountTypeBit63 == 32 && obj.Balance >= 50
    );

    const [promoKey, setPromoKey] = useState(
        loggedResponse?.Promos?.[0]?.PromoKey
    );


    const handleClimbFeatures = async () => {
         debugger;
        if (isPrimrayKey == undefined || isPrimrayKey == null) {
            return
        }
        setIsLoading(true);
        const deviceId = await retrieveData('updatedDeviceId')
        const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
        const url = GET_CLIMB_FEATURES.replace('{CARD_KEY}', isPrimrayKey)
        const response = await GetRequest(url, headers);
        const responseJson = JSON.parse(response);
        if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
            const enabledClimbings = responseJson.Response.filter(
                (response) => response.enabled === true

            );
            setisClimbings(enabledClimbings);
            dispatch({ type: 'UPDATE_CLIMB_FEATURE', payload: { climbFeatures: responseJson.Response } })
            setIsLoading(false);
        } else {
            return [];
        }
    }
  const userMembershipData = getUserMembership(loggedResponse)
  const cardKey = cards?.find(card => card.AccountTypeBit63 === 64)?.CardKey;

      const [agreementType, setAgreementType] = useState([
        {
          name: "Electronic Communications Disclosure and Agreement",
          url: "ESign",
          accType: 64,
          CardKey: cardKey,
        },
        {
          name: "Bancorp Privacy Notice",
          url: "PrivacyPolicyV2",
          accType: 64,
          CardKey: cardKey,
        },
        {
          name: "Kudzu User Agreement",
          url: "TnC",
          accType: 64,
          CardKey: cardKey,
        },
        {
          name: "Kudzu Privacy Policy",
          url: "PPrivacyPolicy",
          accType: 64,
          CardKey: cardKey,
        },
        {
          name: "Demand Deposit Account Agreement",
          url:
            userMembershipData?.membershipType === "Plus" ||
            userMembershipData?.membershipType === "Trial"
              ? "KudzuPlusDepositTerms"
              : "DepositTerms",
          accType: 64,
          CardKey: cardKey,
        },
        {
          name: "Covered by Kudzu Terms and Conditions",
          url:
            userMembershipData?.membershipType === "Plus" ||
            userMembershipData?.membershipType === "Trial"
              ? "CoveredByKudzuPlusTerms"
              : "CoveredByKudzuTerms",
          accType: 64,
          CardKey: cardKey,
        },
        {
          name: "Fees",
          url:
            userMembershipData?.membershipType === "Plus" ||
            userMembershipData?.membershipType === "Trial"
              ? "KudzuPlusFeeMastersV2"
              : "FeeMastersV2",
          accType: 64,
          CardKey: cardKey,
        },
        {
          name: "Kudzu Alerts Terms Of Servies",
          url: "SMSTerms",
          accType: 64,
          CardKey: cardKey,
        },
        {
          name: "Official Sweepstakes Rules",
          url: "PayPerkSweepstakesRules",
          accType: 64,
          CardKey: cardKey,
        },
      ]);

 const isSmiOneIsTrue = useSelector(state => state.smiOneAccountTrue);
    const redirectToPolicy = (policyName, agreementName) => {
        const selectedAgreementType = agreementType.find(agreement => agreement.url === policyName && agreement.name === agreementName);
        dispatch({
            type: "UPDATE_AGREEMENT_TYPE",
            payload: { documentAgreementType: selectedAgreementType },
        });
        navigate(`/Documents/Kudzu/Policies/${selectedAgreementType.name}`);
    };


   
          const handleTermsClick = () => {
              if (accessTokenToApi == undefined || accessTokenToApi == null) {
                  return;
              }
              else {

                  
                  if (isSmiOneIsTrue) {
                      redirectToPolicy(userMembershipData?.membershipType === "Plus" ? "CoveredByKudzuPlusTerms" : "CoveredByKudzuTerms", "Covered by Kudzu Terms and Conditions")

                  } else {
                      navigate('/Documents/Policies/Covered%20by%20Kudzu%20Terms%20and%20Conditions', {
                          state: {
                              name: 'Covered by Kudzu Terms and Conditions',
                              url:
                                  userMembershipData?.membershipType === "Plus" ||
                                      userMembershipData?.membershipType === "Trial"
                                      ? "CoveredByKudzuPlusTerms"
                                      : "CoveredByKudzuTerms", accType: 64, CardKey: cards?.[0]?.CardKey
                          }
                      });
                  }

      
              }
          }
    
    


    // swathi
    const handleClimbFeaturesPlus = async () => {
        // debugger;
        if (isPrimrayKey == undefined || isPrimrayKey == null) {
            return
        }
        setIsLoading(true);
        const deviceId = await retrieveData('updatedDeviceId')
        const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
        const url = GET_CLIMB_FEATURES.replace('{CARD_KEY}', isPrimrayKey)
        const response = await GetRequest(url, headers);
        const responseJson = JSON.parse(response);
        if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
            // debugger;
            const enabledClimbings = responseJson.Response.filter(
                (response) => response.enabled === true

            );
            setisClimbings(enabledClimbings);
            dispatch({ type: 'UPDATE_CLIMB_FEATURE', payload: { climbFeatures: responseJson.Response } })
            setIsLoading(false);
        } else {
            return [];
        }
    }




    const closeSkipModal = () => {
        navigate('/home');
    };


    useEffect(() => {
        const savingsCardExist = cards?.some(item => item.AccountTypeName === "Savings")
        console.log(savingsCardExist, '69841684')
        handleClimbFeatures();
    }, [])

    const canCreateSavingsAccount = async () => {
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
        setIsLoading(true)

        let finalUrl = CAN_CREATE_SAVINGS_ACC(cards[0].CardKey)
        var response = await GetRequest(finalUrl, headers)
        var responseObj = JSON.parse(response)
        setIsLoading(false)
        if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
            const canCreateNew = responseObj.Response.canCreateNew
            const eligibleDate = moment(responseObj.Response.eligibleDate).format('MM/DD/YYYY')
            if (canCreateNew) {
                enrollSavingsAccount()

            } else {
                setIsCoveredByKudzuIneligibleSetupSavings(false);
                showAlertModal(true, t("oh_no"), t('unable_to_open'), `${t('u_will_be_eligible')} ${eligibleDate}. `, true, false, t('home'), '', true, require('../../../../assets/images/illo-report.png'), false, false, true)
            }
        } else {
            setTimeout(() => {
                var arrMessages = responseObj.Messages;
                var message = arrMessages[0];
                var displayText = message.DisplayText;
                showAlertModal(true, t("oh_no"), displayText, '', true, false, t('home'), '', true, require('../../../../assets/images/illo-report.png'), false, false)

                // setError(displayText)
            }, 500);
        }
    }

    const subComponent = () => {
        return (
            <div className=' flex justify-start items-start'>
                <p className="font-hanken-grotesk font-semibold sm:font-[500] sm:text-[14px] md:text-[20px] text-[16px] md:leading-[30px] leading-[24px]">{t("pl_contact_customer")}<span className="text-[#2965FB] cursor-pointer" onClick={
                    () => window.open("https://www.kudzumoney.com/contact-us", '_blank')}>{t("support_email")}</span>{t("for_access")}</p>
            </div>
        )
    }

    const enrollSavingsAccount = () => {
        setIsCoveredByKudzuIneligibleSetupSavings(false);
        setShowPlusModal(false)
        if (kudzuPlusTrue) {
            showAlertModalPlus(true, "", <p className='mb-6'><span className='text-[var(--modal-text-highlight)]'>{t('Let’s_get_started_climb')}</span>{" "}{t('with_creating_a_Kudzu+_savings_account')}</p>,
                t("set_aside_money_for_things_that_matter"),
                false, false, t("enroll"), t("may_be_later"), false,
                require('../../../../assets/kudzu-plus-images/Benificiary.png'), "", true, "#262B3A",
                '', true, '', false, false, false, true, <button type="button"
                    onClick={() => {
                        setIsCoveredByKudzuIneligibleSetupSavingsPostPopup(false); dispatch({ type: 'SSN_SCREEN_THROUGH', payload: { ssnScreenThrough: t('came_from_climb') } });
                        navigate('/SetupSavingsAccount');
                    }}
                    className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[16px] md:text-[16px] sm:text-[14px] text-[16px]
    text-white cursor-pointer flex justify-end items-center w-full" >
                {t('next')} <img
                    src={Arrow}
                    className="md:w-[9px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[9px] h-[14px] ml-2"
                    alt="Arrow" />
            </button>
            );
        }
        else {
            setIsCoveredByKudzuIneligibleSetupSavingsPostPopup(true);
        }
    }

    const closeCustomAlertModal = () => {
        setIsCoveredByKudzuIneligible(false);
        setShowModel(false);
    }

    const onAcptBtnClick = async () => {

        setShowModel(false)
        if (btn1Text == t('home')) {
            navigate('/home')
        }
    }
    const onCancelBtnClick = () => {
        setShowModel(false)

    }

    const showAlertModal = (showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, savingsTheme, isBorderNone, isSubFooter) => {
        setShowModel(showModel)
        setHighlightMsg(highlightMsg)
        setheaderMsg(headerMsg)
        setSubHeaderMsg(subHeaderMsg)
        setBtn1Exists(btn1Exists)
        setBtn2Exists(btn2Exists)
        setBtn1Text(btn1Text)
        setBtn2Text(btn2Text)
        setBtn1TypeAcpt(btn1TypeAcpt)
        setModelImage(modelImage)
        setSavingsTheme(savingsTheme)
        setisBorderNone(isBorderNone)
        setIsSubFooter(isSubFooter)

    }


    const savingsAccount = cards.find(account => account.AccountTypeBit63 == SAVING_CARD_CODE);
    const ClimbData = isClimbings.map(item => generateClimbData(item, savingsAccount, handleTermsClick));
    const savingsCardExist = cards?.some(item => item.AccountTypeName === "Savings")
    //ClimbDataPlus

    // const ClimbDataPlus = isClimbings.map(item => generateClimbDataPlus(item, savingsAccount));

    const callIneligiblePopup = () => {
        setIsCoveredByKudzuIneligibleSetupSavings(true);
        //showAlertModal(true, t('sorry'), t("it_looks_like_your_not_eligible_right_now"), LineBreaks(t("you_need_savings_account")), true, true, t('enroll_in_savings_account'), t('back_to_climb'), true, require('../../../../assets/images/covered_by_kudzu_ineligible.png'), '', false, true)
    }

    const callAddMoneyToSavingsAccount = () => {
        setIsCoveredByKudzuIneligibleSetupSavings(false);
        setIsCoveredByKudzuIneligible(true)
        // showAlertModal(true, t('sorry'), t("it_looks_like_your_not_eligible_right_now"), LineBreaks(t("you_need_savings_account")), true, true, t('add_money_to_savings'), t('back_to_climb'), true, require('../../../../assets/images/covered_by_kudzu_ineligible.png'), '', false, true)
    }

    const climbCard = () => {
        return (
            <>
                {ClimbData.map((climb, index) => (
                    <ClimbCard
                        key={index}
                        image={climb.image}
                        savingsCardExist={savingsCardExist}
                        heading={climb.heading}
                        subheading={climb.subheading}
                        buttonText={climb.buttonText}
                        backgrounblue={index % 2 === 1 ? true : false}
                        RadiusTrue={index % 2 === 1 ? true : false}
                        disabled={climb.Disabled}
                        //    navigateClick= {  ( reactElementToJSXString(climb.subheading).includes('<p>') ) ? savingsCardExist ? !savingsWithBalanceOver50 ? callAddMoneyToSavingsAccount :  climb.link : callIneligiblePopup : climb.link}
                        navigateClick={(climb.heading == t('covered_by_cudzu')) ? savingsCardExist ? !savingsWithBalanceOver50 ? callAddMoneyToSavingsAccount : climb.link : callIneligiblePopup : climb.subheading == t('savigHbitDesc') ? savingsCardExist ? climb.link : callIneligiblePopup : climb.type ? () => {handleCbkClick(climb.type,climb.optinVal)}  : climb.link}
                        // climb.subheading == t('savigHbitDesc')  ||
                        note={climb.note}
                    />
                ))}

                {!kudzuPlusTrue && isShowKudzuPlusPrompt && <FooterContent
                    highlightText={promoKey == PAID_PROMO_KEY ? (t("Climb_to_Greater_Heights_With_a")) : (t("Climb_to_greater_heights_with_a_free_3-Month_Kudzu+"))}
                    subHeaderText={(t("climb_footer_subHeading"))}
                    image={Mask}
                    buttonEnabled={true}
                    btnBgColor={'transparent'}
                    buttonText={t("learn_more")}
                    isSpace={false}
                    subHeaderTextColor={'#FFFFFF'}
                    gradientBackground={Cardbg}
                    btnTextColor={'white'}
                    footerBtnAction={() => {
                        dispatch({ type: 'CLIMB_POPUP_SHOWVALUE', payload: { climbPopShowValue: false } });
                        setShowCarouselScreensShow(false);
                        const currentPath = { currentPathFromStore: currentpath.pathname };
                        dispatch({ type: 'CURRENT_LOCATION', payload: currentPath });
                        showAlertModalPlus(true, t("thanks"), promoKey == PAID_PROMO_KEY ? (t("Climb_to_Greater_Heights_With_a")) : (t("Climb_to_greater_heights_with_a_free_3-Month_Kudzu+")), "", true, true, t('Learn_More'), t('No_Thanks'), true, require('../../../../assets/kudzu-plus-images/leaf.png'), "", true, "#262B3A", addLineBreaks(t('*A_$4.95_monthly_membership_fee_will_be_automatically')), true, '', '', false, true, true);
                        logFirebaseEvents("Climb_Menu", "Kudzu_Plus_Learn_More_Card_Clicked", "Kudzu_Plus_Learn_More_Card_Clicked", "", "");
                    }}
                    type={"climbFooterClimb"}
                    borderDirection={'even'}
                    subHeadingVisiblity={true}
                />}
            </>)
    }

    const showAlertModalPlus = (showPlusModal, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, carousel, isBorderNone, btn1BgColor, summaryParagraph, opacityValue, comparisonScreen, fullWidth, footerButtonEnable, gradientButton, largeImage,subFooter) => {
        setShowPlusModal(showPlusModal)
        setHighlightMsg(highlightMsg)
        setheaderMsg(headerMsg)
        setSubHeaderMsg(subHeaderMsg)
        setBtn1Exists(btn1Exists)
        setBtn2Exists(btn2Exists)
        setBtn1Text(btn1Text)
        setBtn2Text(btn2Text)
        setBtn1TypeAcpt(btn1TypeAcpt)
        setModelImage(modelImage)
        setBtn1Exists(btn1Exists)
        setBtn1Text(btn1Text)
        setCarousel(carousel)
        setisBorderNone(isBorderNone)
        setBtn1BgColor(btn1BgColor)
        setSummaryParagraph(summaryParagraph)
        setOpacityValueLow(opacityValue)
        setComparisonScreen(comparisonScreen)
        setFullWidth(fullWidth)
        setFooterButtonEnable(footerButtonEnable)
        setGradientButton(gradientButton)
        setLargeImage(largeImage)
        setSubFooter(subFooter)
    }

    const climbCardPlus = () => {
        return (
            <>
                {ClimbData.slice(1).map((climb, index) => (
                    <ClimbCardPlus
                        key={index}
                        image={climb.image}
                        savingsCardExist={savingsCardExist}
                        // Add '+' to the first card and "Savings Goals" to the second card
                        // heading={
                        //     <span className="text-white">
                        //         {index === 0
                        //             ? climb.heading + '+' // First card
                        //             : index === 1
                        //                 ? 'Savings Goals'      // Second card
                        //                 : climb.heading}
                        //     </span>
                        // }
                        heading={climb.heading}
                        subheading={<span className="text-white">{climb.subheading}</span>}
                        buttonText={climb.buttonText}
                        backgroundColor={true}
                        RadiusTrue={index % 2 === 0 ? true : false} // Keep your radius logic
                        navigateClick={
                            climb.heading === t('covered_by_cudzu')
                                ? savingsCardExist
                                    ? !savingsWithBalanceOver50
                                        ? callAddMoneyToSavingsAccount
                                        : climb.link
                                    : callIneligiblePopup
                                : climb.subheading === t('savigHbitDesc')
                                    ? savingsCardExist
                                        ? climb.link
                                        : callIneligiblePopup
                                    : climb.link
                        }
                        note={climb.note}
                    />
                ))}
            </>
        );
    };


    const closeModelPlus = () => {
        setShowPlusModal(false)
        setShowCarouselScreensShow(false)
    }
    const onAcptBtnClickPlusModal = () => {
        logFirebaseEvents("Climb_Menu", "Kudzu_Plus_Learn_More_Clicked", "Kudzu_Plus_Learn_More_Clicked", "", "");
        setShowPlusModal(false)
        setShowCarouselScreensShow((prev) => !prev);
        // navigate("/memnershipEnrollmentScreens")
        const data = { kudzuFlowFrom: "Climb" };
        dispatch({ type: 'KUDZU_PLUS_FROM', payload: data });
    }

    const onCancelBtnClickPlusModal = () => {
        logFirebaseEvents("Climb_Menu", "Kudzu_Plus_No_Thanks_Clicked", "Kudzu_Plus_No_Thanks_Clicked", "", "");
        setShowPlusModal(false);
        setShowCarouselScreensShow(false);
    }


    const handleSavingsGoalClick = () =>{
        if (showPrompt) {
            const currentPath = { currentPathFromStore: currentpath.pathname };
            dispatch({ type: 'CURRENT_LOCATION', payload: currentPath });
            setShowCarouselScreensShow((prev) => !prev);
            const data = { kudzuFlowFrom: "climFooter" };
            dispatch({ type: 'KUDZU_PLUS_FROM', payload: data });
        }
        setSavingsGoalsIntoTrue(true)
    }

    
    const handleCbkClick = (item,optinStatus) => {
        debugger;
        switch (item) {
            case COVERED_BY_KUDZU_PLUS:
                if (showPrompt) {
                    const currentPath = { currentPathFromStore: currentpath.pathname };
                    dispatch({ type: 'CURRENT_LOCATION', payload: currentPath });
                    setShowCarouselScreensShow((prev) => !prev);
                    const data = { kudzuFlowFrom: "climbCoveredByKudzu" };
                    dispatch({ type: 'KUDZU_PLUS_FROM', payload: data });
                }
                else {
                    navigate('/Toolkit/CoveredByKudzuPlus');
                }
                break;
            case SAVINGS_GOALS:
                dispatch({ type: "RESET_ALLOCATE_FUND" });
                dispatch({ type: "RESET_SAVING_GOALS" })
                dispatch({
                  type: "SELECTED_FREQUENCY_VALUE",
                  payload: { selectedFrequencyValue : ''  },
                  }); 
                if (showPrompt) {
                    const currentPath = { currentPathFromStore: currentpath.pathname };
                    dispatch({ type: 'CURRENT_LOCATION', payload: currentPath });
                    setShowCarouselScreensShow((prev) => !prev);
                    const data = { kudzuFlowFrom: "climFooter" };
                    dispatch({ type: 'KUDZU_PLUS_FROM', payload: data });
                } else {
                    if (optinStatus) {
                        setSavingsGoalsIntoTrue((prev) => !prev);
                    } else {
                        navigate('/Toolkit/SavingGoals/ManageSavingGoal')
                    }
                }

                break;
            default:
                // Default click handler
                break;
        }
    }

    const initialSavingsGoalModalClose = (val) =>{
        setSavingsGoalsIntoTrue(val)
    }
   




    return (
        <div>
            <HomeLayout>
                <ClimbMenuSidebar />
                <div className='md:w-[150px] sm:w-[70px] w-[0px]'></div>
                <div className='flex justify-center sm:items-stretch flex-col md:w-[860px] sm:w-[464px] 
                 w-[100%] animate__animated animate__fadeInRight  sm:px-0 pl-[2rem] pr-[2.5rem]'>
                    {climbCard()}
                    {/* {kudzuPlusTrue ? climbCardPlus() : ""} */}
                </div>
            </HomeLayout>
            {(isClimbShowPopups || savingsGoalsIntoTrue) && <Climb savingsGoalsIntoTrue = {savingsGoalsIntoTrue} initialSavingsGoalModalClose={initialSavingsGoalModalClose}  />}
            {/* { <Climb/> } */}
            {showCarouselScreenShow &&
                <MemnershipEnrollmentScreens />}
            <CustomAlertModel isOpen={showModel}
                onClose={closeCustomAlertModal}
                image={modelImage}
                zIndex={300}
                highlightMsg={<p className={`${HighlightMsgStyles} sm:flex block flex-col`}>{highlightMsg}
                    <span className={`${HeaderMsgStyles} ${savingsTheme ? 'text-[#0C4437]' : 'text-black'}`}> {headerMsg}</span></p>}
                subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
                btn1Exists={btn1Exists}
                btn2Exists={btn2Exists}
                btn1Text={btn1Text} btn2Text={btn2Text}
                btn1TypeAcpt={btn1TypeAcpt}
                verificationFailure={() => { }}
                footerMsg={<p className={SubHeaderMsgStyles}>{footerMsg}</p>}
                onAcptBtnClick={onAcptBtnClick}
                onCancelBtnClick={onCancelBtnClick}
                isBorderNone={isBorderNone}
                subFooter={isSubFooter && subComponent()}
            />

            {/* these modals im working on  */}
            <Modal
                isOpen={isCoveredByKudzuIneligibleSetupSavings}
                onClose={() => { setIsCoveredByKudzuIneligibleSetupSavings(false); }}
                isClimbg={true}
                Fullheight={true}
                subtitle={<div className="">
                    <span className={SubHeadingStyles2}>{t('sorry')}, </span>
                    <span className={SubHeadingStyles}>{t("it_looks_like_your_not_eligible_right_now")}</span>
                    <p className='mt-4 font-hanken-grotesk font-[500] md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[23px] lg:leading-[30px] md:leading-[30px] leading-[24px] text-[var(--modal-text-heading-clr)]'>
                        {LineBreaks(t("you_need_savings_account_updated"))}</p>
                </div>
                }
                content={<div>

                    <img src={appThemeData.coveredByKudzuIneligibleineligibleIcon} alt=""
                        className="block m-auto lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-16 md:my-14 sm:my-10 my-10" />

                    <div className="flex flex-col justify-center items-center gap-8 w-full">
                        <button
                            type="button"
                            className=" w-full font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-white bg-[#2965FB] cursor-pointer flex justify-center items-center p-4"
                            onClick={canCreateSavingsAccount}
                            autoFocus
                            onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                    canCreateSavingsAccount()
                                    event.stopPropagation();
                                }
                            }}
                        >
                            {t('enroll_in_savings_account')}
                        </button>
                        <button
                            type="button"
                            className={`w-full font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-[var(--modal-text-highlight)] cursor-pointer flex justify-center items-center p-4  sm:border-[0px]  border-[#2965FB] border-[2.5px]`}
                            onClick={() => {
                                setIsCoveredByKudzuIneligibleSetupSavings(false);
                                navigate('/Toolkit/ToolkitMenu');
                            }}
                            onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                    setIsCoveredByKudzuIneligibleSetupSavings(false);
                                    navigate('/Toolkit/ToolkitMenu');
                                    event.stopPropagation();
                                }
                            }}
                        >
                            {t('back_to_climb')}
                        </button>
                    </div>
                </div>}
            />
            <Modal
                // bgColor={'bg-[#FEFAEE]'}
                isOpen={isCoveredByKudzuIneligibleSetupSavingsPostPopup}
                onClose={() => { closeSkipModal(); setIsCoveredByKudzuIneligibleSetupSavingsPostPopup(false); }}
                isClimbg={true}
                Fullheight={true}
                subtitle={<div className="">
                    <span className={SubHeadingStyles2}>{t('lets_get_started').replace('!', '')} </span>
                    <span className={SubHeadingStyles}>{t("with_creating_a_new_account")}</span>
                    <p className='mt-4 font-hanken-grotesk font-[500] md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[23px] lg:leading-[30px] md:leading-[30px] leading-[24px] text-[var(--modal-text-heading-clr)]'>
                        {t("set_aside_money_for_things_that_matter")}</p>
                </div>
                }
                content={<div>

                    <img src={appThemeData.cell} alt="logo" className="block m-auto lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-16 md:my-14 sm:my-10 my-10"  />

                    <div className="flex flex-col justify-center items-center gap-8 w-full">
                        <button
                            type="button"
                            className=" w-full font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-white bg-[#2965FB] cursor-pointer flex justify-center items-center p-4"
                            onClick={() => {
                                setIsCoveredByKudzuIneligibleSetupSavingsPostPopup(false); dispatch({ type: 'SSN_SCREEN_THROUGH', payload: { ssnScreenThrough: t('came_from_climb') } });
                                navigate('/SetupSavingsAccount');
                            }}
                            autoFocus
                            onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                    setIsCoveredByKudzuIneligibleSetupSavingsPostPopup(false);
                                    dispatch({ type: 'SSN_SCREEN_THROUGH', payload: { ssnScreenThrough: t('came_from_climb') } });
                                    navigate('/SetupSavingsAccount');
                                    event.stopPropagation();
                                }
                            }}
                        >
                            {t('continue')}
                        </button>
                    </div>
                </div>}
            />
            <Modal
                isOpen={isCoveredByKudzuIneligible}
                onClose={closeCustomAlertModal}
                isClimbg={true}
                Fullheight={true}
                subtitle={<div className="">
                    <span className={SubHeadingStyles2}>{t('sorry')}, </span>
                    <span className={SubHeadingStyles}>{t("it_looks_like_your_not_eligible_right_now")}</span>
                    <p className='mt-4 font-hanken-grotesk font-[500] md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[23px] lg:leading-[30px] md:leading-[30px] leading-[24px] text-[var(--modal-text-heading-clr)]'>
                        {t("you_need_minimum_50")}</p>
                </div>
                }
                content={<div>

                    <img src={appThemeData.coveredByKudzuIneligibleineligibleIcon} alt=""
                        className="block m-auto lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-16 md:my-14 sm:my-10 my-10" />

                    <div className="flex flex-col justify-center items-center gap-8 w-full">
                        <button
                            type="button"
                            className="focus:outline-none   w-full font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-white bg-[#2965FB] cursor-pointer flex justify-center items-center p-4"
                            onClick={() => { navigate('/AccountServices/Spending/TransferMoney') }}
                            autoFocus
                        >
                            {'Add Money to Savings'}
                        </button>
                        <button
                            type="button"
                            className="w-full font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
                             text-[var(--modal-btn-text-color)] cursor-pointer flex justify-center items-center p-4"
                            onClick={() => {
                                setIsCoveredByKudzuIneligible(false);
                                navigate('/Toolkit/ToolkitMenu');
                            }}>
                            {/* {'Maybe later'} */}
                            {t('back_to_climb')}
                        </button>
                    </div>
                </div>}
            />
            <CustomModalPlus isOpen={showPlusModal} onClose={closeModelPlus}
                image={modelImage}
                carousel={carousel}
                comparisonScreen={comparisonScreen}
                summaryParagraph={summaryParagraph ? <p className={summaryParagraphStyles}>{summaryParagraph}</p> : ""}
                isBorderNone={isBorderNone}
                highlightMsg={<p className={HeaderMsgStylesForPlus}> {headerMsg}</p>}
                subHeaderMsg={subHeaderMsg ? <p className={SubHeaderMsgStylesPlus}>{subHeaderMsg}</p> : ""}
                btn1Exists={btn1Exists}
                btn2Exists={btn2Exists}
                btn1Text={btn1Text}
                btn1BgColor={btn1BgColor}
                btn2Text={btn2Text}
                opacityLow={opacityValueLow}
                defaultCornerRadius={false}
                btn1TypeAcpt={btn1TypeAcpt}
                fullWidth={fullWidth}
                onAcptBtnClick={onAcptBtnClickPlusModal}
                onCancelBtnClick={onCancelBtnClickPlusModal}
                footerButtonEnable={footerButtonEnable}
                skipAndNextButtonsEnable={skipAndNextButtonsEnable}
                gradientButton={gradientButton}
                largeImage={largeImage}
                subFooter={subFooter}
            />

            {isLoading && <Loader />}
        </div>

    )
}

export default withOidcSecure(ClimbMenu)